import LoadingCircle from './Circle/LoadingCircle';

const Loading = {
  Circle: LoadingCircle,
};

export default Loading;
